export const maxLogoWidth = `560px`;
export const maxLogoHeight = `150px`;
export function generateLogo(logoUrl) {
    if (!logoUrl)
        return '';
    return /* html */ `
  <table class="wrapper" role="module" data-type="image" border="0" cellpadding="0"
    cellspacing="0" width="100%" style="table-layout: fixed;"
    data-muid="33d9da39-8bcb-42a0-b2ff-96bf7d6abdeb">
  <tbody>
    <tr>
      <td style="font-size:6px; line-height:10px; padding:0px 0px 0px 0px;" valign="top"
          align="center"> <!-- Changed align="left" to align="center" -->
        <img border="0"
              style="max-width: ${maxLogoWidth}; max-height: ${maxLogoHeight}; display:block; color:#000000; text-decoration:none; font-family:Helvetica, arial, sans-serif; font-size:16px; width:auto; height:auto;"
              alt="" data-proportionally-constrained="true" data-responsive="true"
              src="${logoUrl}">
      </td>
    </tr>
    </tbody>
  </table>
  `;
}
//# sourceMappingURL=generateLogo.js.map